<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model :model="form" ref="resultForm">
        <a-row :gutter="gutter">
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="appCnName"
              label="系统中文名称"
              :rules="{ required: false, message: '请输入系统中文名称', trigger: 'change' }"
            >
              <a-input placeholder="请输入系统中文名称" v-model="form.appCnName" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="appEnName"
              label="系统英文名称"
              :rules="{ required: true, message: '请输入系统英文名称' }"
            >
              <a-input placeholder="请输入系统英文名称" v-model="form.appEnName" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="gutter">
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="appId"
              label="appId"
              :rules="{ required: true, message: '请输入系统 appId', trigger: 'change' }"
            >
              <a-input placeholder="请输入系统 appId" v-model="form.appId" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="indexPage"
              label="系统首页地址"
              :rules="{ required: true, message: '请输入系统首页地址' }"
            >
              <a-input placeholder="请输入系统首页地址" v-model="form.indexPage" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row style="width: 100%">
          <a-col :span="12">
            <a-form-model-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              prop="appDesc"
              label="系统描述"
              :rules="{ required: true, message: '请输入系统描述' }"
            >
              <a-textarea placeholder="请输入系统描述" v-model="form.appDesc" />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="系统图片地址">
              <!-- <a-upload
                name="upfile"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                :multiple="false"
                :data='uploadData'
                :headers="headers"
                :action="uploadAction"
                :before-upload="beforeUpload"
                @change="handleChange"
              >
                <img v-if="previewImage" :src="previewImage" alt="avatar" />
                <div v-else>
                  <a-icon :type="loading ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">上传图片</div>
                </div>
              </a-upload> -->
              <a-upload
                name="upfile"
                :multiple="false"
                :action="uploadAction"
                :data="uploadData"
                :headers="headers"
                :file-list="fileAvatarList"
                @change="handleChange"
              >
                <a-button> <a-icon type="upload" />上传图片 </a-button>
              </a-upload>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
function getBase64(img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
//  const token = Vue.ls.get(ACCESS_TOKEN);
//  const appid = Vue.ls.get(APPID);
import { httpAction } from '@/api/manage'
import { getAction } from '@/api/manage'
import pick from 'lodash.pick'
import moment from 'moment'
import Vue from 'vue'
import { ACCESS_TOKEN, APPID } from '@/store/mutation-types'
export default {
  name: 'SysInfoModal',
  data() {
    return {
      fileAvatarList: [{}],
      title: '操作',
      visible: false,
      uploadAction: `${window._CONFIG['fileUrl']}/uploader/notChunkUploader`,
      id: 0,
      disableSubmit: false,
      gutter: { xs: 8, sm: 16, md: 24, lg: 32 },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },

      confirmLoading: false,
      loading: false,
      previewImage: '',
      form: {},
      url: {
        queryByIds: '/api/atlxsysinfo/queryById',
        add: '/api/atlxsysinfo/add',
        edit: '/api/atlxsysinfo/edit'
      },
      disabled: false,
      headers: {
        authorization: 'authorization-text',
        'X-Access-Token': Vue.ls.get(ACCESS_TOKEN),
        appId: Vue.ls.get(APPID)
      },
      // 初始化，清空上传
      uploadData: {
        filename: '',
        appPhotoGroup: '',
        appPhotoPath: ''
      }
    }
  },
  created() {
    // getAction();
  },
  methods: {
    add() {
      this.id = 0
      this.edit({})
    },
    // 点击编辑，发送的请求
    edit(record) {
      //  this.model = Object.assign({}, record)
      this.disable = false
      this.visible = true
      this.fileAvatarList = []
      //  let that = this;
      if (record.id) {
        getAction(this.url.queryByIds, { id: record.id }).then((res) => {
          this.form = Object.assign({}, this.form, res.result)
          this.id = res.result.id
          // console.log(JSON.stringify(this.form, null, 2));
          console.log('res的结果')
          console.log(res.result)
        })
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.resultForm.resetFields()
      Object.assign(this.$data, this.$options.data.call(this))
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.resultForm.validate((err, values) => {
        if (err) {
          that.confirmLoading = true
          let httpurl = ''
          let method = 'post'
          if (this.id == 0) {
            httpurl += this.url.add
          } else {
            httpurl += this.url.edit
          }

          let formData = Object.assign(this.form, values)
          console.log(formData)
          console.log(1111)
          httpAction(httpurl, formData, method)
            .then((res) => {
              console.log('表单验证结果是')
              console.log(res)
              //  return false;
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      //  1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1)
      this.fileAvatarList = fileList

      if (info.file.status === 'uploading') {
        this.loading = true
        return
      }
      if (info.file.status === 'done') {
        let fileResult = info.file.response.result
        console.log('这是fileResult')
        console.log(fileResult)

        this.form.appPhotoGroup = fileResult.attachGroup
        this.form.appPhotoPath = fileResult.attachPath
        this.form.filename = fileResult.attachName
        console.log('这是form')
        console.log(this.form)

        this.form.appPhoto = fileResult.attachIp + '/' + fileResult.attachPath
        getBase64(info.file.originFileObj, (imageUrl) => {
          this.previewImage = imageUrl
          this.loading = false
        })
      }
    },
    // 上传图片格式验证
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('You can only upload JPG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('Image must smaller than 2MB!')
      }
      return isJpgOrPng && isLt2M
    }
  }
}
</script>

<style scoped>
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
